import "./App.css";
import AppRoutes from "./Routes";
import store from "./redux/store";
import { Provider } from "react-redux";
import { AuthProvider } from "./auth/context/AuthContext";

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Provider>
  );
}

export default App;
